<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="1200" height="800" :show-footer="false" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" title="快递处理" :loading="loading">
			<template #default>
				<el-tabs v-model="tab" type="card">
					<el-tab-pane label="操作" name="list">
						<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
							@toolbar-button-click="list_toolbarButtonClickEvent" ref="deliverytool"></vxe-grid>
					</el-tab-pane>
					<el-tab-pane label="日志" name="log">
						<log-index ref="logIndex" :controlltype="controlltype" />
					</el-tab-pane>
				</el-tabs>
				<exportTable :ref="exportRef" listType="report" />
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import exportTable from '@_system/components/export/index.vue'
	import logIndex from './log/index.vue'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			action: {
				default: () => {
					return ''
				}
			}
		},
		data() {
			return {
				tab: 'list',
				logistics: {
					'中通快运': '中通快运',
					'中通': '中通快递',
					'圆通': '圆通速递',
					'安能': '安能物流',
					'德邦': '德邦快递',
					'极兔': '极兔速递',
					'申通': '申通快递',
					'韵达': '韵达快递',
					'顺丰': '顺丰快递',
					'百世': '百世快递',
					'加运美': '加运美快递',
				},
				controlltype: {
					'催件': '催件',
					'提前揽收': '提前揽收',
					'拦截': '拦截'
				},
				loading: false,
				model: true,
				tableList: [],
				orderinfo: [],
				gridOptions: null,
				tabledata: [],
				exportRef: 'export_' + Math.random(),
				primarykey: '业务订单号',
				importField: {
					'快递单号': 'bizId',
					'处理类型': 'delivery_controll'
				},
				buff: true,
				isfinish: true,
				totalNum: 0,
				progress: 0
			}
		},
		created() {

		},
		mounted() {
			//console.log(this.data)
			this.data.forEach((item) => {
				this.getorderinfo(item)
			})
		},
		watch: {

		},
		computed: {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				let deliveryname = []
				let controlltype = []
				for (let i in this.logistics) {
					deliveryname.push({
						label: this.logistics[i],
						value: this.logistics[i]
					})
				}

				for (let i in this.controlltype) {
					controlltype.push({
						label: this.controlltype[i],
						value: this.controlltype[i]
					})
				}


				gridOptions.height = 650
				gridOptions.importConfig = {
					remote: true,
					importMethod: this.importMethod
				}

				gridOptions.editRules = {
					bizId: [{
						required: true,
						message: false
					}],
					cpName: [{
						required: true,
						message: false
					}],
					delivery_controll: [{
						required: true,
						message: false
					}]
				}
				gridOptions.columns = [{
						type: 'checkbox',
						field: '',
						title: '',
						width: 50,
					}, {
						field: 'bizId',
						title: '快递单号',
					},
					{
						field: 'storage_name',
						title: '仓库'
					},
					{
						field: 'delivery_name',
						title: '快递名称',
						// editRender: {
						// 	name: '$select',
						// 	props: {
						// 		name: '',
						// 		selectoptions: deliveryname
						// 	}
						// }
					},
					{
						field: 'delivery_controll',
						title: '处理类型',
						require: true,
						editRender: {
							name: '$select',
							props: {
								name: '',
								selectoptions: controlltype
							}
						}
					},
					{
						field: '',
						title: '操作',
						width: 65,
						fixed: "right",
						align: 'center',
						cellRender: {
							bind: this,
							name: '$operateButton',
							buttons: [{
								code: 'del',
								content: '删除',
								status: 'danger',
								inrow: true
							}]
						}
					}
				]
				gridOptions.toolbarConfig = {
					zoom: true,
					tools: [{
						toolRender: {
							name: '$batchmodify',
							props: {
								fields: [{
									type: '$select',
									field: 'delivery_controll',
									title: '处理类型',
									options: controlltype,
									props: {
										hidden: false,
										disabled: false,
										readonly: false,
									}
								}],
								buttons: []
							},
							events: {
								submit: (data) => {
									this.toolsSubmit(data)
								}
							}
						}
					}],
					perfect: false,
					size: this.size,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}, {
						name: '导入',
						status: 'success',
						code: 'import'
					}, {
						name: '发送快递群',
						status: 'danger',
						code: 'send'
					}]
				}
				gridOptions.formConfig = false
			},
			toolsSubmit(data) {
				//console.log(this.$refs.deliverytool.getTableData())
				let tableData = this.$refs.deliverytool.getTableData().tableData
				tableData.forEach((item) => {
					for (let i in data.data) {
						item[i] = data.data[i]
					}
				})
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: this.tableList
					})
				})
			},
			operateButtonClickEvent(e) {
				if (this[e.code]) {
					this[e.code](e.data)
				}
			},
			del(row) {
				this.$refs.deliverytool.remove(row)
			},
			getOption() {
				return {
					border: true,
					size: 'mini',
					data: this.tabledata,
					columns: this.columns,
					columnConfig: {
						isHover: false,
						resizable: true
					},
					customConfig: {
						storage: true
					},
					rowConfig: {
						isHover: true,
						isCurrent: true,
					},
					showOverflow: true,
					height: '80%',
					sortConfig: {
						remote: false
					}
				}
			},
			add() {
				this.$prompt('请输入快递单号', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({
					value
				}) => {
					this.getorderinfo(value)
				}).catch(() => {

				});
			},
			getorderinfo(value) {
				this.loading = true
				this.getorderdelivery(value).then((res) => {
					if (res) {
						res[0].delivery_controll = this.action
						this.$refs.deliverytool.insertAt(res, -1)
						this.loading = false
					} else {
						this.loading = false
					}
				}, () => {
					this.loading = false
				})
			},
			send() {
				let data = this.$refs.deliverytool.getCheckboxRecords()
				if (data.length <= 0) {
					return this.$message.error('未选择数据')
				}
				this.$refs.deliverytool.validate(data, (res) => {
					if (!res) {
						this.loading = true
						this.$api.tool.senddelivery({
							data: data,
							staffid:this.$store.state.system.user.id,
						}).then(() => {
							this.$message.success('发送成功')
							this.loading = false
						}, () => {
							this.loading = false
						})
					} else {
						this.$message.error('缺少必填项')

						//console.log(res)
					}
				})
			},
			getorderdelivery(value) {
				return new Promise((reslove) => {
					this.$api.tool.getorderdelivery({
						deliverycode: value
					}).then((res) => {
						res.forEach((item) => {
							for (let i in this.logistics) {
								if (item.delivery_name.includes(i)) {
									item.cpName = this.logistics[i]
									break
								}
							}
						})
						reslove(res)
					}, () => {
						reslove(false)
					})
				})
			},

			exportdata() {
				let columns = JSON.parse(JSON.stringify(this.columns))
				columns.forEach((item) => {
					item.visible = true
				})
				let obj = {
					data: this.tabledata,
					columns: columns
				}
				this.$refs[this.exportRef].exportData(obj)
			},
			importdata() {
				this.$refs.decodeaddressuploadfile.click()
			},
			importMethod(e) {
				this.loading = true
				let file = e.file
				let reader = new FileReader();
				reader.onload = (e) => {
					let data = e.target.result
					let workbook = this.$XLSX.read(data, {
						type: 'binary'
					})
					console.log(workbook)
					let sheetName = workbook.SheetNames[0];
					let worksheet = workbook.Sheets[sheetName]
					let jsonData = this.$XLSX.utils.sheet_to_json(worksheet, {
						defval: null,
						raw: false
					})
					jsonData = jsonData.map(row => {
						let newRow = {};
						for (let key in row) {
							let value = String(row[key]);
							if (value && value != 'null') {
								newRow[key] = value.replace(/\t/g, '');
							}
							// 去除制表符

						}
						return newRow;
					});

					if (jsonData.length != 0) {
						let deliverycode = []
						let data = []
						jsonData.forEach((item) => {
							let obj = {}
							for (let i in this.importField) {
								obj[this.importField[i]] = item[i] ? item[i] : null
								if (item[i] && this.importField[i] == 'bizId') {
									deliverycode.push(item[i])
								}
							}
							data.push(obj)
						})

						data = this.$Lodash.groupBy(data, 'bizId')
						this.getorderdelivery(deliverycode.join(',')).then((res) => {
							res.forEach((item, index) => {
								res[index] = {
									...item,
									...data[item['bizId']][0]
								}
							})
							this.$refs.deliverytool.insertAt(res, -1)
							this.loading = false
						})
					} else {
						this.$message.error('暂无数据')
						this.loading = false
					}
				}
				reader.readAsBinaryString(file)

			},
			show() {
				this.progress = 0
				this.buff = true
			},
			hide() {
				this.progress = 0
				this.buff = false
				this.$emit('hide')
			},
		},
		components: {
			logIndex,
			exportTable
		}
	}
</script>